<section *ngIf="campaign">
    <div id="controls">
        <h1>Controls</h1>
        <button (click)="newCharacter()">New Character</button>
        <button (click)="newCharacter()">New Expedition</button>
    </div>
    <div>
        <h1>Expeditions</h1>
        <ul id="expedition-list">
            <li>Sample Expedition</li>
        </ul>
    </div>
    <div>
        <h1>Characters</h1>
        <ul id="character-list">
            <li *ngFor="let char of campaign.characters">{{char.name}}</li>
        </ul>
    </div>
</section>
<section *ngIf="campaign">
    <h1>Current Item</h1>
    <div id="character" *ngIf="current != null && currentType == 'character'">
        <div class="row">
            <h3><span class="underline">Name</span>:</h3>
            <input [(ngModel)]="current.name" (ngModelChange)="save()" />
        </div>
    </div>
</section>
<section *ngIf="campaign==null">
    loading campaign details...
</section>